<template>
    <div class="w-full overflow-x-auto rounded-lg bg-white">
        <table class="w-full min-w-[700px] text-sm">
            <thead class="border-b border-gray-200 bg-gray-50">
                <tr>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        Label
                    </th>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        Type
                    </th>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        URL
                    </th>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        Target
                    </th>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        External
                    </th>
                    <th class="px-4 py-3 text-left font-semibold text-gray-700">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <template
                    v-for="item in menuItems"
                    :key="item.id"
                >
                    <tr class="border-b border-gray-200 p-4 last:border-b-0">
                        <td
                            class="cursor-pointer px-5 py-4 text-sm font-medium"
                            @click="toggleExpanded(item.id)"
                        >
                            <fa
                                v-if="item.type === 'dropdown'"
                                icon="fa-chevron-down"
                                :class="[
                                    'transition-transform duration-300',
                                    expanded.includes(item.id)
                                        ? 'rotate-180 text-blue-500'
                                        : '',
                                ]"
                            />
                            {{ item.label[activeLocale] }}
                        </td>
                        <td class="px-3 py-4 text-sm font-medium">
                            <span :class="getTypeStyling(item.type)">{{
                                item.type
                            }}</span>
                        </td>
                        <td class="px-3 py-4 text-sm font-medium">
                            {{ item.url?.[activeLocale] }}
                        </td>
                        <td class="px-3 py-4 text-sm font-medium">
                            {{ item.target }}
                        </td>
                        <td class="px-3 py-4 text-sm font-medium">
                            {{ item.isExternal }}
                        </td>
                        <td
                            class="flex space-x-2 px-3 py-4 text-sm font-medium"
                        >
                            <button
                                class="rounded-md bg-blue-500 px-4 py-2 transition-all duration-300 hover:bg-blue-600"
                                @click="handleEdit(item)"
                            >
                                <fa
                                    icon="fa-pen"
                                    class="size-3 text-white"
                                />
                            </button>
                            <button
                                class="rounded-md bg-red-500 px-4 py-2 transition-all duration-300 hover:bg-red-600"
                                @click="handleDelete(item)"
                            >
                                <fa
                                    icon="fa-trash-can"
                                    class="size-3 text-white"
                                />
                            </button>
                            <button
                                v-if="item.type === 'dropdown'"
                                class="rounded-md bg-green-500 px-4 py-2 transition-all duration-300 hover:bg-green-600"
                                @click="handleAddChild(item)"
                            >
                                <fa
                                    icon="fa-plus"
                                    class="size-3 text-white"
                                />
                            </button>
                            <button
                                type="button"
                                class="rounded-md bg-gray-200 px-2"
                                @click="handleMove(item, 'up')"
                            >
                                <fa
                                    icon="fa-chevron-down"
                                    class="size-3 rotate-180 text-black"
                                />
                            </button>
                            <button
                                type="button"
                                class="rounded-md bg-gray-200 px-2"
                                @click="handleMove(item, 'down')"
                            >
                                <fa
                                    icon="fa-chevron-down"
                                    class="size-3 text-black"
                                />
                            </button>
                        </td>
                    </tr>
                    <template v-if="expanded.includes(item.id)">
                        <tr
                            v-for="value in item.children"
                            :key="value.id"
                            class="border-b border-gray-200 bg-gray-100"
                        >
                            <td class="px-8 py-4 text-sm font-medium">
                                └ {{ value.label[activeLocale] }}
                            </td>
                            <td class="px-3 py-4 text-sm font-medium">
                                <span :class="getTypeStyling(value.type)">{{
                                    value.type
                                }}</span>
                            </td>
                            <td class="px-3 py-4 text-sm font-medium">
                                {{ value.url?.[activeLocale] }}
                            </td>
                            <td class="px-3 py-4 text-sm font-medium">
                                {{ value.target }}
                            </td>
                            <td class="px-3 py-4 text-sm font-medium">
                                {{ value.isExternal }}
                            </td>
                            <td class="space-x-2 px-3 py-4 text-sm font-medium">
                                <button
                                    class="rounded-md bg-blue-500 px-4 py-2 transition-all duration-300 hover:bg-blue-600"
                                    @click="handleEdit(value)"
                                >
                                    <fa
                                        icon="fa-pen"
                                        class="size-3 text-white"
                                    />
                                </button>
                                <button
                                    class="rounded-md bg-red-500 px-4 py-2 transition-all duration-300 hover:bg-red-600"
                                    @click="handleDelete(value)"
                                >
                                    <fa
                                        icon="fa-trash-can"
                                        class="size-3 text-white"
                                    />
                                </button>
                                <button
                                    type="button"
                                    class="h-10 rounded-md bg-gray-200 px-2"
                                    @click="handleMoveChild(value, item, 'up')"
                                >
                                    <fa
                                        icon="fa-chevron-down"
                                        class="size-3 rotate-180 text-black"
                                    />
                                </button>
                                <button
                                    type="button"
                                    class="h-10 rounded-md bg-gray-200 px-2"
                                    @click="
                                        handleMoveChild(value, item, 'down')
                                    "
                                >
                                    <fa
                                        icon="fa-chevron-down"
                                        class="size-3 text-black"
                                    />
                                </button>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
import { LocaleMap, PlatformMenuItem } from '@builder/types'
import { ref } from 'vue'

const props = defineProps<{
    menuItems: PlatformMenuItem[]
    activeLocale: keyof LocaleMap
}>()

const emit = defineEmits<{
    (e: 'edit', item: PlatformMenuItem): void
    (e: 'delete', item: PlatformMenuItem): void
    (e: 'addChild', item: PlatformMenuItem): void
    (e: 'reorder', items: PlatformMenuItem[]): void
}>()

const expanded = ref<string[]>([])

const toggleExpanded = (id: string) => {
    const idx = expanded.value.indexOf(id)
    if (idx !== -1) {
        expanded.value.splice(idx, 1)
    } else {
        expanded.value.push(id)
    }
}
const getTypeStyling = (type: 'link' | 'dropdown') => {
    if (type === 'link') {
        return 'bg-blue-300/80 text-blue-800 px-4 py-1 rounded-md capitalize'
    }
    return 'bg-purple-300/70 text-purple-800 px-4 py-1 rounded-md capitalize'
}

const swap = (
    arr: PlatformMenuItem[],
    idx: number,
    direction: 'up' | 'down'
) => {
    const copy = [...arr]
    const target = direction === 'up' ? idx - 1 : idx + 1
    if (target < 0 || target >= copy.length) return copy
    ;[copy[idx], copy[target]] = [copy[target], copy[idx]]
    return copy
}

const handleEdit = (item: PlatformMenuItem) => {
    emit('edit', item)
}

const handleDelete = (item: PlatformMenuItem) => {
    emit('delete', item)
}

const handleAddChild = (item: PlatformMenuItem) => {
    emit('addChild', item)
}

const handleMove = (item: PlatformMenuItem, direction: 'up' | 'down') => {
    const idx = props.menuItems.findIndex((i) => i.id === item.id)
    emit('reorder', swap(props.menuItems, idx, direction))
}

const handleMoveChild = (
    child: PlatformMenuItem,
    parent: PlatformMenuItem,
    direction: 'up' | 'down'
) => {
    const newItems = props.menuItems.map((i) => {
        if (i.id !== parent.id || !i.children) return i
        const idx = i.children.findIndex((c) => c.id === child.id)
        return { ...i, children: swap(i.children, idx, direction) }
    })
    emit('reorder', newItems)
}
</script>
